const AppConfig = {
  api: {
    url: 'https://api.xosoextra.com/'
  }
}

export default AppConfig;
